module.exports = __webpack_public_path__ + "img/bg_arrow.7b003c4b.svg";